
/*
Author: Srinivas P
Date: 11/12/2019
Implementation: Profile Icon is not clickable to Sign Out
search_string: PL-2290
*/
<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>Paygroups</div>
      <template slot="icon" v-if="!showIntro">
        <div class="row-container">
          <div class="showIntro" v-on:click="goToIntro">
            <img class="imgClass" src="@/assets/questionmark.png" />
          </div>
        </div>
      </template>
    </tl-header>
    <div>
      <div class="row-container center">
        <div class="company-info" v-show="showIntro">
          <img class="image" src="@/assets/team.svg" />
          <div v-on:click="hideIntro">
            <img class="closeImage" src="@/assets/close.png" />
          </div>
          <div class="fontStyle">
            <span>Here you will see the list of paygroups in the legal entity. Choose the paygroups you want to run the payroll for.</span>
          </div>
        </div>
      </div>
      <div>
        <paygroups />
      </div>
    </div>
  </div>
</template>

<script>
import Paygroups from "./Paygroups.vue";
export default {
  name: "paygroupsIntro",
  components: { Paygroups },
  data() {
    return {
      showIntro: true
    };
  },
  methods: {
    /** to hide the intro screen if paygroups available */
    hideIntro() {
      this.showIntro = false;
    },
    /** to show the intro screen if paygroups are not available */
    goToIntro() {
      this.showIntro = true;
    },
    /** Navigation */
    cancel() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      });
    },
    next() {}
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/introPage.scss";
//start of code PL-2290
.company-info {
  z-index: -1;
}
//end of code PL-2290
.line {
  border-bottom: 1px solid #34c0be;
  flex-grow: 1;
  margin-top: 25%;
}
.btnGrp {
  float: right;
}
</style>
